import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const AICodeMatrix = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*(){}[]<>~`|\\/ ';
    const aiSymbols = ['λ', 'Δ', 'Σ', 'Π', 'Ω', '∞', '∫', '∂', '∇', '⊕', '⊗', '⊙', '⟨', '⟩', '∈', '∉', '⊂', '⊃', '∪', '∩'];
    const allChars = characters + aiSymbols.join('');

    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = Array(columns).fill(1);
    const speeds = Array(columns).fill(0).map(() => Math.random() * 0.5 + 0.3);

    const draw = () => {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px 'Courier New', monospace`;

      for (let i = 0; i < drops.length; i++) {
        const text = allChars[Math.floor(Math.random() * allChars.length)];
        
        const gradient = ctx.createLinearGradient(
          i * fontSize, drops[i] * fontSize - 100,
          i * fontSize, drops[i] * fontSize
        );
        
        if (Math.random() > 0.7) {
          gradient.addColorStop(0, 'rgba(139, 92, 246, 0.1)');
          gradient.addColorStop(0.5, 'rgba(99, 102, 241, 0.5)');
          gradient.addColorStop(1, 'rgba(59, 130, 246, 1)');
        } else {
          gradient.addColorStop(0, 'rgba(59, 130, 246, 0.1)');
          gradient.addColorStop(0.5, 'rgba(16, 185, 129, 0.5)');
          gradient.addColorStop(1, 'rgba(34, 197, 94, 1)');
        }

        ctx.fillStyle = gradient;
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        if (Math.random() > 0.95) {
          ctx.shadowBlur = 10;
          ctx.shadowColor = 'rgba(139, 92, 246, 0.8)';
          ctx.fillText(text, i * fontSize, drops[i] * fontSize);
          ctx.shadowBlur = 0;
        }

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
          speeds[i] = Math.random() * 0.5 + 0.3;
        }

        drops[i] += speeds[i];
      }
    };

    const animate = () => {
      draw();
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    // Cleanup
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <motion.canvas
      ref={canvasRef}
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.15 }}
      transition={{ duration: 2 }}
      className="fixed inset-0 pointer-events-none z-0 dark:opacity-100 opacity-0"
      style={{ 
        background: 'transparent',
      }}
    />
  );
};

export default AICodeMatrix;
